import React, { ReactElement } from 'react';
import { useTranslate } from 'hooks/translate';
import './styles.scss';

interface ItemProps {
  date: Date;
}

export default function DateBox({ date }: ItemProps): ReactElement {
  const { locale } = useTranslate();
  const month = date.toLocaleString(locale, { month: 'short' });
  const day = date.getDate();

  return (
    <div className='datebox-item'>
      <span>{month}</span>
      <span>{day}</span>
    </div>
  );
}
